import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import reportApi from "../../../../api/reportApi";
import { useReportFilters } from "../../contexts/ReportFiltersContext";
import { formatDuration, formatNumber } from "../../utils/format";
import EmptyState from "../../components/EmptyState";

const StaffTab = () => {
  const { shopId, from, to, isRangeValid } = useReportFilters();
  const auth = useSelector((state) => state.auth);
  const accountId = auth?.user?.accountId;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!shopId || !accountId || !isRangeValid) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    reportApi
      .getStaffLeaderboard({ shopId, accountId, from, to })
      .then((res) => {
        if (cancelled) return;
        if (res.status === 1) setRows(res.data || []);
        else setError(res.message || "Không tải được dữ liệu");
      })
      .catch((err) => !cancelled && setError(err.message))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [shopId, accountId, from, to, isRangeValid]);

  if (!shopId) {
    return (
      <div className="p-6">
        <EmptyState title="Chọn Zalo để xem báo cáo" />
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-100">
          <h2 className="text-sm font-semibold text-gray-900">Xếp hạng nhân viên</h2>
        </div>
        {loading && <div className="p-6 text-sm text-gray-500">Đang tải...</div>}
        {error && <div className="p-6 text-sm text-red-500">Lỗi: {error}</div>}
        {!loading && !error && rows.length === 0 && (
          <EmptyState description="Chưa có hoạt động trong khoảng thời gian này" />
        )}
        {!loading && !error && rows.length > 0 && (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-xs uppercase tracking-wide">
              <tr>
                <th className="px-4 py-2 text-left">#</th>
                <th className="px-4 py-2 text-left">Nhân viên</th>
                <th className="px-4 py-2 text-right">Hội thoại</th>
                <th className="px-4 py-2 text-right">Tin đã gửi</th>
                <th className="px-4 py-2 text-right">Đã phản hồi</th>
                <th className="px-4 py-2 text-right">FRT TB</th>
                <th className="px-4 py-2 text-right">Quá SLA</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr
                  key={row.staffId}
                  className="border-t border-gray-100 hover:bg-gray-50"
                >
                  <td className="px-4 py-2 text-gray-500">{idx + 1}</td>
                  <td className="px-4 py-2">
                    <div className="flex items-center gap-2">
                      {row.staffAvatar ? (
                        <img
                          src={row.staffAvatar}
                          alt=""
                          className="w-6 h-6 rounded-full object-cover"
                        />
                      ) : (
                        <div className="w-6 h-6 rounded-full bg-gray-200" />
                      )}
                      <span className="font-medium text-gray-900">
                        {row.staffName || "—"}
                      </span>
                    </div>
                  </td>
                  <td className="px-4 py-2 text-right font-medium">
                    {formatNumber(row.conversationsHandled)}
                  </td>
                  <td className="px-4 py-2 text-right">
                    {formatNumber(row.messagesSent)}
                  </td>
                  <td className="px-4 py-2 text-right">
                    {formatNumber(row.respondedCount)}
                  </td>
                  <td className="px-4 py-2 text-right">
                    {formatDuration(row.avgFrtSeconds)}
                  </td>
                  <td className="px-4 py-2 text-right">
                    {row.timeouts > 0 ? (
                      <span className="text-red-600 font-medium">
                        {formatNumber(row.timeouts)}
                      </span>
                    ) : (
                      <span className="text-gray-400">0</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default StaffTab;
